export default __webpack_public_path__ + "locales/vi/EmptyView.json?hash=8f9db4be1c543507ee8f4f4b404075a7";